import { scan } from "@pdfking/rfunc"
/**
 * register plugins
 */
import append from "./append"

export default <K extends keyof HTMLElementTagNameMap>(
  t: K,
  attrs: Record<string, string> = {},
  inner: any = null
): HTMLElementTagNameMap[K] => {
  const element = document.createElement(t)
  scan((v: string, k: string) => element.setAttribute(k, v), attrs)
  append(element, inner)
  return element
}
